module.exports = __webpack_public_path__ + "static/08-uni-319343@2x-49436d7e1084b2cf3f1c262d94d679c2.png";